var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper",class:{ collapsed: !_vm.sidebarOpened }},[_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('navbar'),_c('div',{staticClass:"content-scroll"},[_c('app-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }